import { fieldValidationMessages } from 'app/constants';

export const defaultValues = {
  isPrivate: false,
  isDownloadable: false,
  isStreamable: true,
};

export const extendedDefaultValues = {
  ...defaultValues,
  playlist: {
    type: '',
    genre: null,
    description: '',
  },
};

export const multiTrackFormErrorMessages = {
  errors: {
    playlist: {
      description: {
        maxLength: (props: [string, { maxLength: number }]) => {
          return fieldValidationMessages.MAX_CHAR(props[1].maxLength);
        },
      },
    },
  },
};
